class AuthModule then constructor: -> return [
]

class AuthEvents
  constructor: ->
    return {
      loginSuccess: 'auth-login-success'
      loginFailed: 'auth-login-failed'
      logoutSuccess: 'auth-logout-success'
      sessionTimeout: 'auth-session-timeout'
      notAuthenticated: 'auth-not-authenticated'
      notAuthorized: 'auth-not-authorized'
    }

class AuthOptions
  constructor: ->
    @login_url  = "/login"

    @$get = ->
      return {
        login_url : @login_url
      }

    @set_login_url = (login_url) ->
      return @login_url if not login_url
      @login_url = login_url
      return



class Session
  constructor: ->
    @create = (sessionId, userId, userRoles) ->
      @id = sessionId
      @userId = userId
      @userRoles = userRoles
      return
    @destroy = ->
      @id = null
      @userId = null
      @userRoles = null
      return
    return this

class AuthService
  constructor: ($http, sessionService, authOptions) ->
    authService =
      login : (credentials) ->
        return $http.post(authOptions.login_url, credentials).then (res) ->
          sessionService.create(res.data.id, res.data.user.id,
            res.data.user.roles)
          return res.data.user
      isAuthenticated : () ->
        return true if sessionService.userId
      isAuthorized : (authorizedRoles) ->
        if not angular.isArray authorizedRoles
          authorizedRoles = [authorizedRoles]
        return authService.isAuthenticated() and
          _.intersection(authorizedRoles, sessionService.userRoles).length > 0
    return authService

class Login
  constructor: ($scope, $rootScope, AUTH_EVENTS, AuthService) ->
    $scope.credentials =
      username : ''
      password : ''
    $scope.login = (credentials) ->
      AuthService.login(credentials).then((user) ->
        $rootScope.$emit AUTH_EVENTS.loginSuccess
        $scope.setCurrentUser user
        return
      , () ->
        $rootScope.$emit AUTH_EVENTS.loginFailed
        return
      )

class OmniaAuth
  constructor: ->
    directive =
      restrict: 'A'

      controller : ($scope, AuthService) ->
        $scope.currentUser = null
        $scope.userRoles = null
        $scope.isAuthorized = AuthService.isAuthorized

        $scope.setCurrentUser = (user) ->
          $scope.currentUser = user
          return

        return
    return directive

class OmniaAuthRunner
  constructor: ($rootScope, AUTH_EVENTS, AuthService) ->
    checkNavAuthorization = (event, next) ->
      authorizedRoles = (next.data or next.$$route?.data)?.authorizedRoles
      if authorizedRoles? and not AuthService.isAuthorized authorizedRoles
        event.preventDefault()
        if AuthService.isAuthenticated()
          #user is not allowed
          $rootScope.$emit AUTH_EVENTS.notAuthorized, next
          return
        else
          #user is not logged in
          $rootScope.$emit AUTH_EVENTS.notAuthenticated, next
          return
    $rootScope.$on('$stateChangeStart', checkNavAuthorization)
    $rootScope.$on('$routeChangeStart', checkNavAuthorization)

class AuthTokenInterceptor
  constructor: ($q, sessionService) ->
    addToken =
      request: (config) ->
        if sessionService.id?.headerName
          config.headers[sessionService.id.headerName] =
            sessionService.id.authToken
        config or $q.when(config)
      ,
      response: (response) ->
        response or $q.when(response)
      ,
      responseError: (rejection) ->
        $q.reject(rejection)

    return addToken

class AuthToken
  constructor: ($httpProvider) ->
    $httpProvider.interceptors.push 'AuthTokenInterceptor'


angular.module('omnia.auth', new AuthModule())
.constant('AUTH_EVENTS', AuthEvents())
.provider('authOptions', [AuthOptions])
.service('sessionService', [Session])
.factory('AuthService', ['$http', 'sessionService', 'authOptions', AuthService])
.controller('loginController', ['$scope', '$rootScope', 'AUTH_EVENTS', 'AuthService', Login])
.directive('omniaAuth', [OmniaAuth])
.run(['$rootScope', 'AUTH_EVENTS', 'AuthService', OmniaAuthRunner])
.factory('AuthTokenInterceptor', ['$q', 'sessionService', AuthTokenInterceptor])
.config(['$httpProvider', AuthToken])